<template>
  <div class="login">
    <div class='header'>
      <div>
        <img class='soft_logo_img' src='../assets/soft_logo.jpg' />
        <span>MSMT</span>
      </div>
      <div class='soft_title'>

        <p>集测量方法、算法于一体的工具软件</p>
      </div>
    </div>
    <div class="content">

      <a-tabs defaultActiveKey="1" :animated='false' size='large' :tabBarGutter='30' @change="callback">
        <a-tab-pane tab="账户密码登录" key="1">
          <el-form ref="form" :model="auth" :rules="validatePass">
            <el-form-item prop="tel">
              <el-input placeholder=" 用户名" v-model="auth.tel">
                <i slot="prefix" class="el-input__icon el-icon-document"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input placeholder=" 密码" v-model="auth.password" type="password">
                <i slot="prefix" class="el-input__icon el-icon-edit"></i>
              </el-input>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked" style="float:left;">自动登录</el-checkbox>
              <el-button type="text" style="float:right;">忘记密码</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="login()" style="width:100%">登录</el-button>
            </el-form-item>
            <!-- <el-form-item>
                其他登录方式
              <el-button type="primary" @click="login()" style="width:100%"></el-button>
            </el-form-item> -->
          </el-form>
        </a-tab-pane>
        <a-tab-pane tab="手机号登录" key="2" forceRender>
          <el-form ref="loginForm" :model="auth" :rules="validateCode">
            <el-form-item prop="tel">
              <el-input placeholder=" 手机号" v-model="auth.tel">
                <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="randomCode">
              <el-input placeholder=" 验证码" v-model="auth.randomCode" style='width:230px;float:left;'>
                <i slot="prefix" class="el-input__icon el-icon-message"></i>
              </el-input>
              <el-button style="float:right;padding: 11px 20px;" @click='getcode'>获取验证码</el-button>
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="checked" style="float:left;">自动登录</el-checkbox>
              <el-button type="text" style="float:right;">忘记密码</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="code_login()" style="width:100%">登录</el-button>
            </el-form-item>
          </el-form>
        </a-tab-pane>
      </a-tabs>
    </div>

    <Footer></Footer>

  </div>

</template>

<script>
import Footer from '@/components/footer/footer.vue'
var Base64 = require('js-base64').Base64
export default {
  name: 'home',
  components: {
    Footer
  },
  data () {
    var validateIdentity = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('手机号不能为空'))
      }
      // 匹配手机号规则
      if (/^1(3|4|5|7|8)[0-9]\d{8}$/.test(value)) {
        callback()
        return
      }
      callback(new Error('手机号格式不匹配'))
    }
    return {
      auth: {
        tel: ''
      },
      checked: false,
      validatePass: {
        tel: [{
          validator: validateIdentity,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '密码不能为空',
          trigger: 'blur'
        }]
      },

      validateCode: {
        tel: [{
          validator: validateIdentity,
          trigger: 'blur'
        }]
      }
    }
  },
  methods: {
    callback (key) {
      console.log(key)
    },
    login () {
      this.$refs.form.validate(async valid => {
        if (valid) {
          var user = {
            tel: this.auth.tel,
            password: this.auth.password
          }
          var data = await this.$$login({ user, mac: '', type: 'password' })

          this.$store.dispatch('update_remember', {
            token: data.token
          })
          var id = JSON.parse(Base64.decode(data.token.split('.')[1])).uid

          // 获取userinfo
          var userinfo = await this.$$getUserinfo(id)
          this.$store.dispatch('update_userinfo', {
            userinfo
          })
          if (userinfo) {
            this.$router.push('/user')
          }
        }
      })
    },
    getcode: async function () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          await this.$$getCode({ tel: this.auth.tel, type: 'login' })
        }
      })
    },
    code_login () {
      this.$refs.loginForm.validate(async valid => {
        if (valid) {
          var user = {
            tel: this.auth.tel,
            androidId: 'androidId'
          }
          var data = await this.$$login({ user, randomCode: this.auth.randomCode, type: 'randomCode' })

          this.$store.dispatch('update_remember', {
            token: data.token
          })
          var id = JSON.parse(Base64.decode(data.token.split('.')[1])).uid

          // 获取userinfo
          var userinfo = await this.$$getUserinfo(id)
          this.$store.dispatch('update_userinfo', {
            userinfo
          })
          if (userinfo) {
            this.$router.push('/user')
          }
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: rgb(240,242,245);
    background-image: url('../assets/background.svg');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .content{
        width: 360px;
        margin: auto;
    }
    .header{
      margin-top: 50px;
      .soft_logo_img{
        width: 50px;
        margin-right: 30px;
      }
      span{
        font-weight: 600;
        font-size: 33px;
        position: relative;
        bottom: -7px;
      }
      .soft_title{
          font-size: 14px;
          color: rgba(0,0,0,.45);
          margin-top: 12px;
          margin-bottom: 40px;
      }
    }
}
</style>
